module.exports = __webpack_public_path__ + "media/images/main_eventapp-f9465779.jpg";